var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-footer"},[_c('img',{staticClass:"sydw",attrs:{"src":require("../../../assets/custom/hlj/index/footer-icon.png"),"alt":""}}),_c('span',[_vm._v("黑龙江农业经济职业学院版权所有")]),_c('span',[_vm._v("中国黑龙江省牡丹江市西安区")]),_c('span',[_vm._v("邮编：157041")]),_c('span',[_vm._v("电话：0453-6402306")]),_c('span',[_vm._v("黑ICP备06005807号-1")])])
}]

export { render, staticRenderFns }